import POSConfigModule from "@/store/modules/pos-config";
import request from "@/utils/request";

export async function checkTerminal(uniqueTerminalId?: string): Promise<any> {
  let response: any;
  if (uniqueTerminalId) {
    const params = {
      uniqueTerminalId: uniqueTerminalId,
    };
    response = await request({
      method: "GET",
      url: `/adyen-terminal/${POSConfigModule.groupId}/connected-terminals`,
      params,
    });
  } else {
    response = await request({
      method: "GET",
      url: `/adyen-terminal/${POSConfigModule.groupId}/connected-terminals`,
    });
  }

  return response.data;
}
